"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AXSIcon_1 = __importDefault(require("../AXSIcon"));
var colors_1 = require("../../constants/colors");
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var get_1 = __importDefault(require("lodash/get"));
var utils_1 = require("../../utils");
var TagContainer = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  border: ", ";\n  color: ", ";\n  display: inline-flex;\n  font-size: 12px;\n  line-height: 28px;\n  margin: 0 5px;\n  padding: 2px 8px;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n"], ["\n  background-color: ",
    ";\n  border-radius: ", ";\n  border: ",
    ";\n  color: ", ";\n  display: inline-flex;\n  font-size: 12px;\n  line-height: 28px;\n  margin: 0 5px;\n  padding: 2px 8px;\n\n  &:hover {\n    background-color: ",
    ";\n    color: ", ";\n  }\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme;
    return utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.WHITE);
}, function (_a) {
    var borderRadius = _a.borderRadius, theme = _a.theme;
    return get_1.default(theme, borderRadius, '8px');
}, function (_a) {
    var borderWidth = _a.borderWidth, borderColor = _a.borderColor, theme = _a.theme;
    return borderWidth + " solid " + utils_1.parseThemePath(borderColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var backgroundColorHover = _a.backgroundColorHover, theme = _a.theme;
    return utils_1.parseThemePath(backgroundColorHover, theme, colors_1.colors.WHITE);
}, function (_a) {
    var colorHover = _a.colorHover, theme = _a.theme;
    return utils_1.parseThemePath(colorHover, theme, colors_1.colors.BLUE_300);
});
var TagIcon = styled_components_1.default(AXSIcon_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: ", ";\n  line-height: 26px;\n  margin-left: 2px;\n  opacity: ", ";\n  vertical-align: -1px;\n"], ["\n  cursor: ", ";\n  line-height: 26px;\n  margin-left: 2px;\n  opacity: ", ";\n  vertical-align: -1px;\n"])), function (_a) {
    var readOnly = _a.readOnly;
    return readOnly ? 'default' : 'pointer';
}, function (_a) {
    var readOnly = _a.readOnly;
    return readOnly ? '.5' : '1';
});
var AXSTagDefaults = {
    backgroundColor: 'axsui.components.tag.backgroundColor',
    backgroundColorHover: 'axsui.components.tag.backgroundColorHover',
    borderColor: 'axsui.components.tag.borderColor',
    borderColorHover: 'axsui.components.tag.borderColorHover',
    borderRadius: 'axsui.components.tag.borderRadius',
    borderWidth: '1px',
    color: 'axsui.components.tag.color',
    colorHover: 'axsui.components.tag.colorHover',
    iconColor: 'axsui.component.tag.iconColor',
    label: '',
};
var AXSTag = function (_a) {
    var color = _a.color, backgroundColor = _a.backgroundColor, iconColor = _a.iconColor, onRemove = _a.onRemove, label = _a.label, value = _a.value, readOnly = _a.readOnly, borderRadius = _a.borderRadius, borderColor = _a.borderColor, borderWidth = _a.borderWidth, theme = _a.theme, props = __rest(_a, ["color", "backgroundColor", "iconColor", "onRemove", "label", "value", "readOnly", "borderRadius", "borderColor", "borderWidth", "theme"]);
    return (React.createElement(TagContainer, __assign({}, props, { color: color, backgroundColor: backgroundColor, borderRadius: borderRadius, borderWidth: borderWidth, borderColor: borderColor }),
        label,
        onRemove &&
            React.createElement(TagIcon, { onClick: function () { return (readOnly ? undefined : onRemove(value)); }, color: utils_1.parseThemePath(iconColor, theme, colors_1.colors.BLUE_300), name: "close", readOnly: readOnly })));
};
AXSTag.defaultProps = AXSTagDefaults;
exports.default = AXSTag;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map